import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router';
import { useDispatch } from 'react-redux';
import Overlay from '../../components/Overlay';
import { useCartPlaceOrderMutation } from '../../components/Cart/apiSlice';
import { getLocation } from '../../env-vars';
import { updateBadgeCount } from '../../store/shared/cartSlice';

function CheckoutCallback() {
  const { accountId } = useParams();
  const dispatch = useDispatch();
  const queryParams = new URLSearchParams(window.location.search);
  const navigate = useNavigate();

  const getQueryParam = (key: string) => queryParams.get(key) ?? '';
  const [placeOrder] = useCartPlaceOrderMutation();

  useEffect(() => {
    const payload = {
      hmacSignature: getQueryParam('hmacSignature'),
      methodSubtype: getQueryParam('paymentMethodSubtype'),
      methodType: getQueryParam('paymentMethodType'),
      payData: getQueryParam('paydata'),
      paymentReference: getQueryParam('paymentReference'),
      paymentStatus: getQueryParam('paymentStatus'),
      returnUrl: `${getLocation()}/hub/${accountId}/checkout-callback`,
      convertToOrder: true,
    };

    if (
      payload.paymentStatus?.toLowerCase() === 'cancelled' ||
      document.referrer.includes('partner')
    ) {
      navigate(`/hub/${accountId}`);
    } else {
      placeOrder({ accountId, body: payload })
        .unwrap()
        .then((response) => {
          // make sure to reset count to 0
          dispatch(updateBadgeCount(0));
          navigate(`/hub/${accountId}/confirmation/${response.orderId}`);
        })
        .catch((err) => {
          console.error(err);
        });
    }
  }, []);

  return (
    <Overlay
      variant="PMIOverlay"
      global
      animated
      fade
      iconColor="brand-dark"
      overlayColor="black"
      overlayOpacity={1}
      show
    />
  );
}

export default CheckoutCallback;
